import type { LucideIcon } from 'lucide-react'
import {ArrowUpRight} from 'lucide-react'
import { Link } from 'react-router-dom'

interface LinkButtonProps {
  icon: LucideIcon
  title: string
  description?: string
  href?: string
  onClick?: () => void
  external?: boolean
  image?: string
}

function LinkButton({ icon: Icon, title, description, href, onClick, external, image }: LinkButtonProps) {
  const className = 'group w-full flex items-center gap-4 rounded-2xl bg-[#3d2b1f] hover:bg-[#4a3626] border border-amber-800/30 hover:border-amber-500/50 px-5 py-4 transition-colors text-left animate-fade-in-up'

  const content = (
    <>
      {image ? (
        <div className="w-11 h-11 rounded-xl overflow-hidden shrink-0">
          <img src={image} alt="" className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="w-11 h-11 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0">
          <Icon className="w-5 h-5 text-amber-400" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="text-amber-50 font-semibold text-base leading-tight">{title}</p>
        {description ? <p className="text-amber-100/60 text-sm mt-0.5 leading-snug">{description}</p> : null}
      </div>
      <ArrowUpRight className="w-4 h-4 text-amber-400/70 group-hover:text-amber-300 shrink-0" />
    </>
  )

  if (href) {
    if (!external && href.startsWith('/')) {
      return (
        <Link to={href} className={className}>
          {content}
        </Link>
      )
    }

    return (
      <a
        href={href}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        className={className}
      >
        {content}
      </a>
    )
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {content}
    </button>
  )
}

export default LinkButton
